import { ChevronLeft, ChevronLeftCircle, ChevronRightCircle, Footprints, Goal, X } from 'lucide-react';
import React, { useState, useEffect } from 'react';
import { FaInstagram } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import Pagination from '../components/Pagination';
import { motion, useMotionValue, animate } from "framer-motion";
import TeamSlider from '../components/TeamSlider';

export default function About() {
  const [visibleSections, setVisibleSections] = useState(new Set());
  
  const [active, setActive] = useState(0);

  const [selectedProject, setSelectedProject] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [about, setAbout] = useState([]);
  const [mission, setMission] = useState([]);

  const items = [
    { title: "Reliable", icon: "/images/radar/reliable.png" },
    { title: "Accurate", icon: "/images/radar/accurate.png" },
    { title: "Dedicated", icon: "/images/radar/dedicated.png" },
    { title: "Advanced", icon: "/images/radar/advanced.png" },
    { title: "Responsive", icon: "/images/radar/responsive.png" },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActive((prev) => (prev + 1) % items.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  const size = 700;
  const center = size / 2;
  const radius = 280; // jarak dari tengah

  // hitung posisi segi lima secara matematis
  const coords = items.map((_, i) => {
    const angle = (i * 72 - 90) * (Math.PI / 180);
    return {
      x: center + radius * Math.cos(angle),
      y: center + radius * Math.sin(angle),
    };
  });

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('[data-section]');
      sections.forEach(section => {
        const rect = section.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight * 0.75 && rect.bottom > 0;
        
        if (isVisible) {
          setVisibleSections(prev => new Set([...prev, section.getAttribute('data-section')]));
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const [filter, setFilter] = useState('all');
  
    useEffect(() => {
      const handleScroll = () => {
        const sections = document.querySelectorAll('[data-section]');
        sections.forEach(section => {
          const rect = section.getBoundingClientRect();
          const isVisible = rect.top < window.innerHeight * 0.75 && rect.bottom > 0;
          
          if (isVisible) {
            setVisibleSections(prev => new Set([...prev, section.getAttribute('data-section')]));
          }
        });
      };
  
      window.addEventListener('scroll', handleScroll);
      handleScroll();
      return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const [dataGallery, setDataGallery] = useState([]);
    const [dataTeam, setDataTeam] = useState([]);
    const [page, setPage] = useState(1);
    const [pageTeam, setPageTeam] = useState(1);
    const [total, setTotal] = useState(1);
    const [totalTeam, setTotalTeam] = useState(1);
    const [category, setCategory] = useState("");

    const fetchDataGallery = async () => {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/gallery?page=${page}&category=${category}`
      );
      const json = await res.json();

      setDataGallery(json.data);
      setTotal(json.total_pages);
    };

    useEffect(() => {
      fetchDataGallery();
    }, [page, category]);

    const fetchDataTeam = async () => {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/teams`
      );
      const json = await res.json();

      setDataTeam(json.data);
      setTotalTeam(json.total_pages);
    };

    useEffect(() => {
      fetchDataTeam();
    }, [pageTeam, category]);
  
    const categories = [
      { id: 'all', name: 'Semua Foto & Video' },
      { id: 'anniv', name: 'Anniversary Radar Pulsa' },
      { id: 'liburan', name: 'Radar Pulsa Liburan' },
      { id: 'tahunan', name: 'Acara Tahunan Radar Pulsa' },
      { id: 'berbagi', name: 'Radar Pulsa Berbagi' },
    ];
  
    const filteredProjects = filter === 'all' 
      ? dataGallery 
      : dataGallery.filter(p => p.category === filter);

    const fetchAbout = async () => {
      
      try {
          const res = await fetch(
              `${process.env.REACT_APP_BASE_URL}api/about/1`
          );
  
          if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
  
          const json = await res.json();
          setAbout(json.data || []);
  
      } catch (err) {
          console.error("Fetch About error:", err);
      }
    };
    
    useEffect(() => {
      fetchAbout();
    }, []);  

    const fetchMission = async () => {
        try {
          const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/mission`);
    
          if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
          }
    
          const note = await res.json();
          const list = Array.isArray(note) ? note : note.data || [];
    
          setMission(list);
        } catch (err) {
          console.error("Gagal mengambil data:", err);
        }
      };
        
      useEffect(() => {
        fetchMission();
      }, []);
    
    const x = useMotionValue(0);

  const loopData = [...dataTeam, ...dataTeam];

    useEffect(() => {
      const controls = animate(x, -2000, {
        ease: "linear",
        duration: 25,
        repeat: Infinity,
        repeatType: "loop"
      });

      return controls.stop;
    }, []);

  
  const fetchSectionHero = async () => {
    
    try {
        const res = await fetch(
            `${process.env.REACT_APP_BASE_URL}api/sectionhero/about`
        );

        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

        const json = await res.json();
        setSectionHero(json.data[0] || []);

    } catch (err) {
        console.error("Fetch Pc error:", err);
    }
  };
  
  useEffect(() => {
    fetchSectionHero();
  }, []);  

  const [sectionHero, setSectionHero] = useState({
    title: "",
    page: "",
    description: "",
    image: "", 
  });    

  return (
    <div className="min-h-screen bg-slate-950 text-white pt-20">
      {/* Header Section */}
      <section
        data-section="header"
        className="
          relative
          h-[32vh] md:h-[40vh] lg:h-[45vh]
          overflow-hidden
          flex items-center justify-center
          bg-slate-950
        "
      >
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src={`${process.env.REACT_APP_BASE_URL}uploads/images/${sectionHero.image}`}
            alt="background"
            className="w-full h-full object-cover"
          />
          
          {/* Overlay depth */}
          <div className="absolute inset-0 bg-slate-950/60"></div>

          {/* Gradient Glow */}
          <div className="absolute inset-0 bg-gradient-to-b from-slate-900/30 via-slate-950/50 to-slate-950"></div>

          {/* Optional Glow Accent */}
          <div className="absolute top-1/4 left-1/3 w-72 h-72 bg-blue-500/20 blur-[120px] rounded-full"></div>
          <div className="absolute bottom-1/4 right-1/3 w-72 h-72 bg-red-500/20 blur-[120px] rounded-full"></div>
        </div>

        {/* Content */}
        <div
          className={`
            relative z-10
            px-6
            text-center
            max-w-5xl
            mx-auto
            translate-y-[2vh]
            transition-all duration-1000
            ${
              visibleSections.has("header")
                ? "opacity-100"
                : "opacity-0 translate-y-[5vh]"
            }
          `}
        >
          <h1
            className="
              font-bricolage
              font-bold
              tracking-tight
              leading-tight
              mb-4
              bg-gradient-to-r
              from-blue-400 via-white to-red-400
              bg-clip-text text-transparent
              text-[clamp(2rem,6vw,4.5rem)]
            "
          >
            {sectionHero.page}
          </h1>

          <div className="w-16 md:w-24 h-1 rounded-full bg-gradient-to-r from-blue-500 to-red-500 mx-auto mb-5"></div>

          <p
            className="
            mx-auto
            max-w-xs sm:max-w-2xl
            text-gray-300
            leading-relaxed
            text-[clamp(.95rem,1.8vw,1.15rem)]
            "
          >
            {sectionHero.description}
          </p>
        </div>
      </section>

      {/* Story Section */}
      <section 
        data-section="story"
        className="py-24 bg-slate-950"
      >
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-200 ${
          visibleSections.has('story') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="px-6">
              <h1 className="
              text-6xl font-bold text-white font-bricolage
              font-bold
              tracking-tight
              leading-tight
              mb-4
              bg-gradient-to-r
              from-blue-400 via-white to-red-400
              bg-clip-text text-transparent
              text-[clamp(2rem,6vw,4.5rem)]"
              >
                {about.title}
              </h1>
              <p className="
                text-gray-400 
                mx-auto
                max-w-xs sm:max-w-2xl
                text-gray-300
                leading-relaxed
                text-[clamp(.95rem,1.8vw,1.15rem)]">
                {about.description}
              </p>
            </div>

            <div className="relative px-4 md:px-0">
              {/* GLOW */}
              <div className="absolute inset-0 bg-gradient-to-br from-blue-600/30 to-red-600/30 rounded-2xl blur-2xl"></div>

              {/* CARD */}
              <div className="relative bg-slate-800/50 backdrop-blur-sm p-5 md:p-8 rounded-2xl border border-slate-700">
                
                <div className="space-y-4 md:space-y-6">

                  {/* VISI */}
                  <div className="flex items-start gap-3 md:gap-4">
                    
                    {/* ICON */}
                    <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-blue-600 to-red-600 rounded-lg flex items-center justify-center flex-shrink-0">
                      <Goal size={20} className="md:w-9 md:h-9 text-white" />
                    </div>

                    {/* TEXT */}
                    <div>
                      <h3 className="text-base md:text-xl font-bold mb-1 md:mb-2 font-bricolage">
                        Visi
                      </h3>
                      <p className="text-gray-400 text-sm md:text-base leading-relaxed">
                        {about.visi}
                      </p>
                    </div>
                  </div>

                  {/* MISI */}
                  <div className="flex items-start gap-3 md:gap-4">
                    
                    {/* ICON */}
                    <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-blue-600 to-red-600 rounded-lg flex items-center justify-center flex-shrink-0">
                      <Footprints size={20} className="md:w-9 md:h-9 text-white" />
                    </div>

                    {/* TEXT */}
                    <div>
                      <h3 className="text-base md:text-xl font-bold mb-1 md:mb-2 font-bricolage">
                        Misi
                      </h3>

                      <ol className="list-decimal list-outside text-gray-400 ml-4 space-y-1 text-sm md:text-base leading-relaxed">
                        {mission.map((item, index) => (
                          <li key={index}>{item.mission}</li>
                        ))}
                      </ol>
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section 
        data-section="values"
        className="hidden lg:block  bg-gradient-to-b from-slate-950 to-slate-900"
      >
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-300 ${
          visibleSections.has('values') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          
          <div className="w-full flex flex-col items-center py-20 text-white">
            <h2 className="font-bricolage text-5xl font-bold mb-20 tracking-widest bg-gradient-to-r from-blue-400 to-red-400 bg-clip-text text-transparent">
              R.A.D.A.R Values
            </h2>

            <div
              className="relative"
              style={{ width: size, height: size }}
            >
              {/* SVG Lines */}
              <svg
                width={size}
                height={size}
                className="absolute inset-0"
              >
                {coords.map((point, index) => {
                  const next = (index + 1) % coords.length;
                  return (
                    <line
                      key={index}
                      x1={point.x}
                      y1={point.y}
                      x2={coords[next].x}
                      y2={coords[next].y}
                      stroke={active === index ? "url(#grad)" : "rgba(255,255,255,0.08)"}
                      strokeWidth="4"
                      className="transition-all duration-700"
                    />
                  );
                })}

                <defs>
                  <linearGradient id="grad">
                    <stop offset="0%" stopColor="#06b6d4" />
                    <stop offset="100%" stopColor="#f71414" />
                  </linearGradient>
                </defs>
              </svg>

              {/* BOX */}
              {coords.map((point, index) => (
                <div
                  key={index}
                  className={`absolute w-48 h-48 bg-slate-900 rounded-2xl 
                  border border-white/10 flex flex-col items-center justify-center gap-4
                  transition-all duration-500
                  ${active === index 
                    ? "scale-125 bg-slate-800 shadow-[0_0_35px_rgba(99,102,241,0.6)]" 
                    : "scale-100"
                  }`}
                  style={{
                    left: point.x - 96,
                    top: point.y - 96,
                  }}
                >
                  <img src={items[index].icon} alt="" className="h-24" />
                  <h3 className="text-lg font-semibold">
                    {items[index].title}
                  </h3>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section 
        data-section="filter"
        className="py-8 bg-slate-950"
      >
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-200 ${
          visibleSections.has('filter') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setFilter(category.id)}
                className={`px-6 py-3 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105 ${
                  filter === category.id
                    ? 'bg-gradient-to-r from-blue-600 to-red-600 text-white shadow-lg shadow-blue-500/50'
                    : 'bg-slate-800 text-gray-400 hover:text-white hover:bg-slate-700'
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Projects Grid */}
      <section 
        data-section="projects"
        className="py-12 md:py-16 bg-slate-950"
      >
        <div
          className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-300 ${
            visibleSections.has('projects')
              ? 'opacity-100 translate-y-0'
              : 'opacity-0 translate-y-10'
          }`}
        >

          {/* GRID */}
          <div className="
            grid 
            grid-cols-1 
            sm:grid-cols-2 
            lg:grid-cols-3 
            gap-4 md:gap-8
            max-w-md sm:max-w-none mx-auto
          ">
            
            {filteredProjects.map((project, index) => (
              <div
                key={project.id}
                className="
                  group relative overflow-hidden rounded-xl md:rounded-2xl
                  bg-slate-800/50 border border-slate-700
                  hover:border-blue-500/50
                  transition-all duration-500
                  md:hover:scale-105
                "
                style={{
                  transitionDelay: `${index * 100}ms`,
                  animation: 'fadeIn 0.5s ease-out'
                }}
              >
                
                {/* IMAGE */}
                <div className="aspect-video relative overflow-hidden">
                  
                  <img
                    src={`${process.env.REACT_APP_BASE_URL}uploads/images/${project.thumb}`}
                    alt=""
                    className="
                      w-full h-full object-cover
                      transition-transform duration-500
                      md:group-hover:scale-110
                    "
                  />

                  {/* OVERLAY */}
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 to-transparent opacity-60 md:opacity-0 md:group-hover:opacity-100 transition-opacity duration-300" />

                  {/* BUTTON */}
                  <div className="
                    absolute inset-0 flex items-center justify-center
                    opacity-100 md:opacity-0 md:group-hover:opacity-100
                    transition-opacity duration-300
                  ">
                    <button
                      onClick={() => {
                        setSelectedProject(project);
                        setCurrentIndex(0);
                      }}
                      className="
                        px-4 py-2 md:px-6 md:py-3
                        bg-white text-slate-900
                        rounded-lg font-semibold
                        text-sm md:text-base
                        hover:bg-gray-100
                        transition
                      "
                    >
                      Lihat Galeri
                    </button>
                  </div>

                </div>

                {/* CONTENT */}
                <div className="p-4 md:p-6">
                  <h3 className="text-base md:text-xl font-bold mb-1 md:mb-2 text-white md:group-hover:text-blue-400 transition-colors duration-300">
                    {project.title}
                  </h3>

                  <p className="text-gray-400 text-xs md:text-sm line-clamp-2">
                    {project.description}
                  </p>
                </div>

              </div>
            ))}
          </div>

          {/* PAGINATION */}
          <div className="mt-8 md:mt-10">
            <Pagination
              current={page}
              total={total}
              onPageChange={setPage}
            />
          </div>

          {/* EMPTY */}
          {filteredProjects.length === 0 && (
            <div className="text-center py-12 md:py-16">
              <p className="text-gray-400 text-base md:text-lg">
                Galeri tidak ditemukan.
              </p>
            </div>
          )}
        </div>
      </section>

      {/* Team Section */}
      <section 
        data-section="team"
        className="pt-24 bg-slate-900"
      >
        <div className={`w-full px-4 py-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-400 ${
          visibleSections.has('team') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-red-400 to-blue-400 bg-clip-text text-transparent">
              Tim Radar Pulsa
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-red-500 to-blue-500 mx-auto mb-4"></div>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto">
              Mereka yang selalu hadir untuk men-support Mitra Radar dengan Integritas tinggi.
            </p>
          </div>

          <div className="w-full grid md:grid-cols-1 gap-8 overflow-hidden">
            <TeamSlider dataTeam={dataTeam}></TeamSlider>
          </div>
        </div>
      </section>
      

      {/* Stats Section */}
      {/* <section 
        data-section="stats"
        className="py-24 bg-gradient-to-b from-slate-900 to-slate-950"
      >
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-500 ${
          visibleSections.has('stats') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-blue-400 to-red-400 bg-clip-text text-transparent">
              Our Impact
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-red-500 mx-auto"></div>
          </div>

          <div className="grid md:grid-cols-2 gap-12">
            {[
              { number: '500+', label: 'Projects Completed', desc: 'Successfully delivered across various industries' },
              { number: '200+', label: 'Happy Clients', desc: 'Building long-term partnerships worldwide' },
              { number: '50+', label: 'Expert Team', desc: 'Dedicated professionals with diverse expertise' },
              { number: '15+', label: 'Years Experience', desc: 'Proven track record of excellence' },
            ].map((stat, index) => (
              <div
                key={index}
                className="flex items-center space-x-6 p-8 bg-slate-800/50 backdrop-blur-sm rounded-2xl border border-slate-700 hover:border-blue-500/50 transition-all duration-300 transform hover:scale-105"
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <div className={`text-5xl font-bold ${
                  index % 2 === 0 
                    ? 'bg-gradient-to-r from-blue-400 to-cyan-400' 
                    : 'bg-gradient-to-r from-red-400 to-pink-400'
                } bg-clip-text text-transparent`}>
                  {stat.number}
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold mb-1 text-white">{stat.label}</h3>
                  <p className="text-gray-400 text-sm">{stat.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}
      {/* CTA Section */}
      <section 
        data-section="cta"
        className="py-24 bg-gradient-to-b from-slate-900 to-slate-950 relative overflow-hidden"
      >
        <div className="absolute inset-0">
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl"></div>
        </div>

        <div
          className={`relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 delay-400 ${
            visibleSections.has('cta')
              ? 'opacity-100 translate-y-0'
              : 'opacity-0 translate-y-10'
          }`}
        >
          {/* TITLE */}
          <h2 className="font-bricolage text-2xl sm:text-3xl md:text-5xl font-bold mb-4 md:mb-6 bg-gradient-to-r from-blue-400 to-red-400 bg-clip-text text-transparent leading-tight">
            Ayo bergabung menjadi mitra Kami!
          </h2>

          {/* DESC */}
          <p className="text-sm sm:text-base md:text-xl text-gray-400 mb-6 md:mb-8 max-w-xl mx-auto leading-relaxed">
            Kami tidak hanya menyediakan layanan, tetapi membangun kemitraan jangka panjang untuk perkembangan bisnis Anda.
          </p>

          {/* BUTTON */}
          <div className="flex justify-center">
            <Link
              to="https://play.google.com/store/apps/details?id=com.otoreport.radarpulsa&hl=id"
              target="_blank"
              className="
                w-full sm:w-auto
                px-6 sm:px-8 md:px-10
                py-3 sm:py-4
                bg-gradient-to-r from-blue-600 to-red-600
                rounded-full
                font-semibold
                text-sm sm:text-base md:text-lg
                text-center
                hover:shadow-xl md:hover:shadow-2xl
                hover:shadow-blue-500/40
                transform md:hover:scale-105
                transition-all duration-300
              "
            >
              Mulai mendaftar
            </Link>
          </div>
        </div>
      </section>
      {selectedProject && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">

          {/* Glass Background */}
          <div
            className="absolute inset-0 bg-black/40 backdrop-blur-xl"
            onClick={() => setSelectedProject(null)}
          />

          {/* Modal Content */}
          <div className="
            relative
            w-full
            max-w-6xl
            h-[75vh] md:h-[80vh]
            bg-white/10
            backdrop-blur-2xl
            border border-white/20
            rounded-xl md:rounded-2xl
            overflow-hidden
            shadow-2xl
          ">
            {/* Close Button */}
            <button
              onClick={() => setSelectedProject(null)}
              className="absolute top-3 right-3
                md:top-4 md:right-4
                z-50
                text-white
                text-xl md:text-2xl"
            >
              <X></X>
            </button>

            {/* Slider Content */}
            <div className="relative w-full h-full flex items-center justify-center overflow-hidden">

              {/* Slide */}
              <div
                className="w-full h-full flex transition-transform duration-500 ease-in-out"
                style={{
                  transform: `translateX(-${currentIndex * 100}%)`
                }}
              >
                {selectedProject.items.map((item, index) => (
                  <div
                    key={index}
                    className="w-full p-4 flex-shrink-0 flex items-center justify-center"
                  >
                    {item.filetype === "image" ? (
                      <img
                        src={`${process.env.REACT_APP_BASE_URL}uploads/gallery/${item.filename}`}
                        alt=""
                        className="max-h-[65vh] md:max-h-[70vh] w-auto object-contain rounded-xl"
                      />
                    ) : (
                      <video
                        src={`${process.env.REACT_APP_BASE_URL}uploads/gallery/${item.filename}`}
                        controls
                        className="max-h-[65vh] md:max-h-[70vh] w-auto rounded-xl"
                      />
                    )}
                  </div>
                ))}
              </div>

              {/* Navigation Buttons */}
              <button
                onClick={() =>
                  setCurrentIndex((prev) =>
                    prev === 0
                      ? selectedProject.items.length - 1
                      : prev - 1
                  )
                }
                className="absolute left-4 text-white text-3xl transform hover:scale-125 duration-500"
              >
                <ChevronLeftCircle size={48}></ChevronLeftCircle>
              </button>

              <button
                onClick={() =>
                  setCurrentIndex((prev) =>
                    prev === selectedProject.items.length - 1
                      ? 0
                      : prev + 1
                  )
                }
                className="absolute right-4 text-white text-3xl  transform hover:scale-125 duration-500"
              >
                <ChevronRightCircle size={48}></ChevronRightCircle>
              </button>

            </div>
          </div>
        </div>
      )}

    </div>
  );
}
